import React from 'react';

import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import Router from '@module/router';
import I18n from '@module/i18n';

import API from '@app/api';

import Icon from '@component/icon';
import Pagination from '@component/pagination';
import AdGallery from '@component/advertise/adgallery';

const ADVERT_GALLERY_URL = new URL(
  'https://s3-eu-west-1.amazonaws.com/wetransfer-extra/advertgallery'
);
const ADVERT_GALLERY = ADVERT_GALLERY_URL.href;
const ITEMS_PER_PAGE = 48;

export default class Gallery extends React.Component {
  static propTypes = {
    page: PropTypes.object,
    route: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      items: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const response = await API.Advertise.getGalleryItems();
    if (response.status === 200) {
      const json = response.body;
      this.setState({
        loaded: true,
        items: json.images,
      });
    }
  }

  resetTag = (event) => {
    event.preventDefault();
    Router.navigateTo(
      '/advertise/gallery',
      false,
      this.buildSearchQueryParams({ tag: null })
    );
  };

  handleClickOnPagination = (page) => {
    Router.navigateTo(
      '/advertise/gallery',
      false,
      this.buildSearchQueryParams({ p: page + 1 })
    );
    if (this.props.page.scrollableNode) {
      this.props.page.scrollableNode.scrollTo(this.parent, {
        animated: true,
        duration: 200,
      });
    }
  };

  handleClickOnTag = (tag) => {
    Router.navigateTo(
      '/advertise/gallery',
      false,
      this.buildSearchQueryParams({ p: null, tag })
    );
    if (this.props.page.scrollableNode) {
      this.props.page.scrollableNode.scrollTo(this.parent, {
        animated: true,
        duration: 200,
      });
    }
  };

  showWallpaper(e, previewLink) {
    if (typeof e.target.className !== 'string') {
      return;
    }

    if (!Browser.isMobile && e.target.className.indexOf('tag') === -1) {
      Router.navigateTo(previewLink, false, false, {
        backTo: window.location.pathname + window.location.search,
        backButtonText: I18n.t('page.advertise.button.back'),
      });
    }
  }

  buildSearchQueryParams(newParams) {
    const currentPage = this.getCurrentPage();
    const currentTag = this.getCurrentTag();
    const oldParams = { p: currentPage + 1, tag: currentTag };
    const params = { ...oldParams, ...newParams };
    const queryParams = [];
    if (params.p) {
      queryParams.push(`p=${params.p}`);
    }
    if (params.tag) {
      queryParams.push(`tag=${params.tag}`);
    }
    const search = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
    return { search };
  }

  getCurrentPage() {
    const route = this.props.route;
    let currentPage = 1;
    if (!isNaN(parseInt(route.query.p))) {
      currentPage = parseInt(route.query.p);
    }
    if (currentPage <= 1) {
      currentPage = 1;
    }
    return currentPage - 1;
  }

  getCurrentTag() {
    const route = this.props.route;
    return route.query.tag;
  }

  render() {
    const loaded = this.state.loaded;
    let items = this.state.items;
    const currentPage = this.getCurrentPage();
    const currentTag = this.getCurrentTag();

    if (currentTag) {
      items = items.filter(
        (item) => item.tags && item.tags.includes(currentTag)
      );
      if (loaded && items.length < 1) {
        Router.navigateTo(
          '/advertise/gallery',
          false,
          this.buildSearchQueryParams({ tag: null })
        );
      }
    }

    const pages = Math.floor(
      (items.length + ITEMS_PER_PAGE - 1) / ITEMS_PER_PAGE
    );
    const pagination =
      pages > 1 ? (
        <Pagination
          pages={pages}
          activePage={currentPage}
          onClick={this.handleClickOnPagination}
        />
      ) : null;
    const start = currentPage ? currentPage * ITEMS_PER_PAGE : 0;

    const gallery = items
      .slice(start, start + ITEMS_PER_PAGE)
      .map((item, index) => {
        const wallpaper = item.homepage.replace(/^.*\/\/[^/]+/, '');
        const tags =
          item.tags !== null && item.tags !== undefined ? item.tags : [];

        return (
          <AdGallery
            key={index}
            image={`${ADVERT_GALLERY}/photos/${item.filename}`}
            title={item.author}
            description={item.description}
            type={item.type}
            tags={tags}
            onTagSelect={this.handleClickOnTag}
            onPreview={(e) => this.showWallpaper(e, wallpaper)}
          />
        );
      });

    return (
      <div
        className="page-advertise page-advertise-gallery"
        ref={(node) => (this.parent = node)}
      >
        <div className="page-advertise-gallery__intro">
          <h1>{I18n.t('page.advertise.gallery.intro.title')}</h1>
          {!currentTag && (
            <p
              dangerouslySetInnerHTML={{
                __html: I18n.t('page.advertise.gallery.intro.description'),
              }}
            />
          )}
          {currentTag && (
            <div className="page-advertise-gallery__filters">
              <a href="#" onClick={this.resetTag}>
                <span className="filter">{currentTag}</span>
                <Icon className="icon" type="Close" />
              </a>
            </div>
          )}
        </div>
        {loaded && (
          <div className="page-advertise-gallery__content">{gallery}</div>
        )}
        {!loaded && (
          <div className="page-advertise-gallery__content">
            <AdGallery placeholder={true} />
            <AdGallery placeholder={true} />
            <AdGallery placeholder={true} />
            <AdGallery placeholder={true} />
            <AdGallery placeholder={true} />
            <AdGallery placeholder={true} />
          </div>
        )}
        {loaded && pagination}
      </div>
    );
  }
}
